<div class="intro-line-1" i18n="product group spanish translations title">
  Spanish Translations
</div>

@if (form) {
  <ng-content>
    <form (ngSubmit)="onSave()" [formGroup]="form">
      <client-header
        [headerLabel]="'Product Group Information'"
        [headerGroup]="'productGroupInfo'"
        (click)="headerGroups.productGroupInfo = !headerGroups.productGroupInfo"
        >
      </client-header>
      @if (headerGroups.productGroupInfo) {
        <div class="collapse-container">
          <rn-text-input
            [inputLabel]="'Product group feed display name'"
            [inputControl]="form.controls['name']"
            [placeholderText]="'Product group feed display name'"
            [isWide]="true"
            [maxLength]="getCharacterLimit('feedDisplayName')"
            >
            <rn-input-info-box
              input-info-box
              [svgHeight]="60"
              [svgPosition]="'8,0 8,24, 2,30 8,36 8,80'"
              [text]="'Enter Spanish display name, only if different from existing product group display name.'"
            ></rn-input-info-box>
          </rn-text-input>
          <div class="input-container" style="display: flex">
            <div class="input">
              <label i18n="Label for product description"
                >Product description</label
                >
                <rn-form-input-state-control
                  [formReference]="form.controls['description']"
                  [showCharacterCount]="true"
                  [totalLength]="getCharacterLimit('description')"
                  >
                  <ng-container>
                    <textarea
                      id="product-description"
                      placeholder="Add a brief description here"
                      id="product-description-input"
                      i18n-placeholder="Placeholder text for product description"
                      spellcheck="false"
                      [formControl]="form.controls['description']"
                    ></textarea>
                  </ng-container>
                </rn-form-input-state-control>
              </div>
            </div>
          </div>
        }
        @if (this?.client?.fdic_enabled) {
          <client-header
            [headerLabel]="'FDIC Signage'"
            [headerGroup]="'fdic'"
            (click)="headerGroups.fdic = !headerGroups.fdic"
            >
          </client-header>
          @if (headerGroups.fdic) {
            <div class="collapse-container">
              <div class="input-container" style="display: flex">
                <div class="input">
                  <label i18n="Label for non-deposit language"
                    >Non-deposit language</label
                    >
                    <rn-form-input-state-control
                      [formReference]="form.controls['fdicNonDepositLanguage']"
                      [showCharacterCount]="true"
                      [totalLength]="getCharacterLimit('fdicNonDepositLanguage')"
                      >
                      <ng-container>
                        <textarea
                          [placeholder]="nonDepositLanguageSpanish"
                          id="non-deposit-language-input"
                          spellcheck="false"
                          (blur)="handleNonDepositLanguageFocusOut()"
                          [formControl]="form.controls['fdicNonDepositLanguage']"
                        ></textarea>
                      </ng-container>
                    </rn-form-input-state-control>
                  </div>
                </div>
              </div>
            }
          }
          <client-header
            [headerLabel]="'Disclaimer'"
            [headerGroup]="'disclaimer'"
            (click)="headerGroups.disclaimer = !headerGroups.disclaimer"
          ></client-header>
          @if (headerGroups.disclaimer) {
            <div class="collapse-container">
              <div class="input-container">
                <div class="input">
                  <label i18n="Disclaimer that appears at end of every message/feed"
                    >Disclaimer</label
                    >
                    <div style="display: flex">
                      <rn-form-input-state-control
                        [formReference]="form.controls['disclaimer']"
                        [showCharacterCount]="true"
                        [totalLength]="getCharacterLimit('disclaimer')"
                        >
                        <ng-container>
                          <app-tiny-editor
                            class="tiny-editor-mentions"
                            [elementId]="'tiny-editor-disclaimer'"
                            [formControl]="form.controls['disclaimer']"
                            >
                          </app-tiny-editor>
                        </ng-container>
                      </rn-form-input-state-control>
                    </div>
                  </div>
                </div>
              </div>
            }
            <client-header
              [headerLabel]="'Terms & Conditions'"
              [headerGroup]="'tnc'"
              (click)="headerGroups.tnc = !headerGroups.tnc"
            ></client-header>
            @if (headerGroups.tnc) {
              <div class="collapse-container">
                <div style="display: flex">
                  <div class="input-container" style="flex: 1">
                    <div class="input">
                      <label>Express Consent Ts&Cs</label>
                      <div style="display: flex">
                        <rn-form-input-state-control
                          [formReference]="form.controls['expressConsentTC']"
                          [showCharacterCount]="true"
                          [totalLength]="getCharacterLimit('expressConsentTsCs')"
                          >
                          <ng-container>
                            <app-tiny-editor
                              class="tiny-editor-mentions"
                              [elementId]="'tiny-editor-expressConsentTC'"
                              [formControl]="form.controls['expressConsentTC']"
                              >
                            </app-tiny-editor>
                          </ng-container>
                        </rn-form-input-state-control>
                      </div>
                    </div>
                  </div>
                  <div class="input-container" style="flex: 1">
                    <div class="input">
                      <label>Express Written Consent Ts&Cs</label>
                      <div style="display: flex">
                        <rn-form-input-state-control
                          [formReference]="form.controls['expressWrittenConsentTC']"
                          [showCharacterCount]="true"
                          [totalLength]="getCharacterLimit('expressWrittenConsentTsCs')"
                          >
                          <ng-container>
                            <app-tiny-editor
                              class="tiny-editor-mentions"
                              [elementId]="'tiny-editor-expressWrittenConsentTC'"
                              [formControl]="form.controls['expressWrittenConsentTC']"
                              >
                            </app-tiny-editor>
                          </ng-container>
                        </rn-form-input-state-control>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="display: flex">
                  <div class="input-container" style="flex: 1">
                    <div class="input">
                      <label>In Feed Consent Upgrade Ts&Cs</label>
                      <div style="display: flex">
                        <rn-form-input-state-control
                          [formReference]="form.controls['inFeedConsentUpgradeTC']"
                          [showCharacterCount]="true"
                          [totalLength]="getCharacterLimit('inFeedConsentUpgradeTsCs')"
                          >
                          <ng-container>
                            <app-tiny-editor
                              class="tiny-editor-mentions"
                              [elementId]="'tiny-editor-inFeedConsentUpgradeTC'"
                              [formControl]="form.controls['inFeedConsentUpgradeTC']"
                              >
                            </app-tiny-editor>
                          </ng-container>
                        </rn-form-input-state-control>
                      </div>
                    </div>
                  </div>
                  @if (this?.productGroup?.password?.tc_enabled) {
                    <div
                      class="input-container"
                      style="flex: 1"
                      >
                      <div class="input">
                        <label>Password Page Ts&Cs</label>
                        <div style="display: flex">
                          <rn-form-input-state-control
                            [formReference]="form.controls['passwordPageTC']"
                            [showCharacterCount]="true"
                            [totalLength]="getCharacterLimit('passwordTsCs')"
                            >
                            <ng-container>
                              <app-tiny-editor
                                class="tiny-editor-mentions"
                                [elementId]="'tiny-editor-passwordPageTC'"
                                [formControl]="form.controls['passwordPageTC']"
                                >
                              </app-tiny-editor>
                            </ng-container>
                          </rn-form-input-state-control>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            @if (productGroup.onboarding.sign_up_page.enabled === 'true') {
              <client-header
                [headerLabel]="'Signup Page'"
                [headerGroup]="'signup'"
                (click)="headerGroups.signup = !headerGroups.signup"
              ></client-header>
              @if (headerGroups.signup && client.validation.fields) {
                <div
                  class="collapse-container"
                  >
                  <rn-sign-up-form
                    [client]="client"
                    [productGroup]="productGroup"
                    [express_written_consent_ts_cs]="this.form.get('expressWrittenConsentTC').value"
                    [signUpGroup]="form.controls['signup']"
                  ></rn-sign-up-form>
                  <rn-generic-phone class="generic-phone" [overflowY]="'auto'">
                    <sign-up-page-preview-react
                      [messageText]="this.form.get('signup.message_text').value || productGroup.onboarding.sign_up_page?.message_text"
            [ccidInputLabel]=" this.form.get('signup.ccid_input_label').value ||
        productGroup.onboarding.sign_up_page?.ccid_input_label
      "
            [mobileInputLabel]="this.form.get('signup.mobile_input_label').value ||
        productGroup.onboarding.sign_up_page?.mobile_input_label
      "
                      [validationFields]="validationFields"
                      [logoUrl]="productGroup.branding.icon_s3_url"
                      [bannerUrl]="productGroup.branding.banner_s3_url"
                      [color]="productGroup.branding.color"
                      [productGroupName]="this.form.get('name').value || productGroup.name"
                      [showProductGroup]="!productGroup.hide_pg_wire_display_name"
                      [productGroupDescription]="this.form.get('description').value || productGroup.description"
            [expressWrittenConsentTsCs]="this.form.get('expressWrittenConsentTC').value ||
        productGroup.consent?.express_written_consent_ts_cs
      "
            [submitBtnLabel]="this.form.get('signup.submit_button_label').value ||
        productGroup.onboarding.sign_up_page?.submit_button_label
      "
            [termsAndConditionsText]="this.form.get('signup.terms_and_conditions_text').value ||
        productGroup.onboarding.sign_up_page?.terms_and_conditions_text"
            [termsAndConditionsValidationError]="this.form.get('signup.terms_and_conditions_validation_error').value ||
        productGroup.onboarding.sign_up_page?.terms_and_conditions_validation_error"
                      [showBranding]="productGroup.onboarding.sign_up_page.display_branding"
                      [hideProductGroupWireDisplayName]="productGroup.hide_pg_wire_display_name"
                      [showFdic]="productGroup.fdic.show_signage_on_authentication"
                      [fdic]="productGroup.fdic"
                      [showBanner]="productGroup.show_banner"
                      [showLogo]="productGroup.show_logo"
                      [showTitleBar]="productGroup.show_title_bar"
                    ></sign-up-page-preview-react>
                  </rn-generic-phone>
                </div>
              }
            }
            @if (!!productGroup && !!client && client.verification.enabled === 'true') {
              <client-header
                [headerLabel]="'Verification'"
                [headerGroup]="'verification'"
                (click)="headerGroups.verification = !headerGroups.verification"
                >
              </client-header>
              @if (headerGroups.verification && client.validation.fields) {
                <div
                  class="collapse-container"
                  style="display: flex"
                  >
                  <rn-generic-phone [size]="'large'">
                    <rn-verification-preview
                      [pswEnabled]="productGroup.password.enabled"
                      [pswTCS]="productGroup.password.tcs"
                      [showTCS]="productGroup.password.tc_enabled"
                      [pswTCMandatory]="productGroup.password.tc_mandatory"
                      [fields]="verificationFields"
                      [logoUrl]="productGroup.branding.icon_s3_url"
                      [color]="productGroup.branding.color"
                      [productGroupName]="productGroup.name"
                      [showProductGroup]="!productGroup.hide_pg_wire_display_name"
                      [productGroupDescription]="productGroup.description"
                      [showFdic]="productGroup.fdic.show_signage_on_authentication"
                      [fdic]="productGroup.fdic"
                      [showBanner]="productGroup.show_banner"
                      [bannerUrl]="productGroup.branding.banner_s3_url"
                      [bannerAltText]="productGroup.branding.banner_alt_text"
                      [showLogo]="productGroup.show_logo"
                      [showTitleBar]="productGroup.show_title_bar"
                      [consentTSCS]="productGroup.consent.in_wire_upgrade.ts_cs"
            [verificationBody]="
            this.form.get('verificationFields.body').value
          "
            [verificationHeader]="
            this.form.get('verificationFields.header').value
          "
            [verificationButtonLabel]="
            this.form.get('verificationFields.button_label').value
          "
                    ></rn-verification-preview>
                  </rn-generic-phone>
                  <div
                    class="messaging-panel verification"
                    formGroupName="verificationFields"
                    >
                    <div class="card panel-default">
                      <div class="card-header">
                        <div class="col-sm-12">Verification Page Content</div>
                      </div>
                      <div class="card-body">
                        <div class="form-group">
                          <rn-text-input
                            [inputLabel]="'Heading'"
                            [inputControl]="this.form.get('verificationFields.header')"
                            [placeholderText]="'Account Confirmation'"
                            [isFullWidth]="true"
                            >
                          </rn-text-input>
                        </div>
                        <div class="form-group">
                          <label class="input-label">Verification Fields</label>
                          <div class="validation-fields-container">
                            <span class="validation-field-label"> first_name </span>
                            <span class="validation-field-input">
                              <rn-form-input-state-control
                                [formReference]="form.get('verificationFields.first_name')"
                                >
                                <input
                                  type="text"
                                  class="form-control"
                                  name="prompt-first_name"
                                  formControlName="first_name"
                                  />
                              </rn-form-input-state-control>
                            </span>
                          </div>
                          <div class="validation-fields-container">
                            <span class="validation-field-label"> last_name </span>
                            <span class="validation-field-input">
                              <rn-form-input-state-control
                                [formReference]="form.get('verificationFields.last_name')"
                                >
                                <input
                                  type="text"
                                  class="form-control"
                                  name="prompt-last_name"
                                  formControlName="last_name"
                                  />
                              </rn-form-input-state-control>
                            </span>
                          </div>
                          <div class="validation-fields-container">
                            <span class="validation-field-label"> ssn_last4 </span>
                            <span class="validation-field-input">
                              <rn-form-input-state-control
                                [formReference]="form.get('verificationFields.ssn_last4')"
                                >
                                <input
                                  type="text"
                                  class="form-control"
                                  name="prompt-ssn_last4"
                                  formControlName="ssn_last4"
                                  />
                              </rn-form-input-state-control>
                            </span>
                          </div>
                          <div class="validation-fields-container">
                            <span class="validation-field-label"> date_of_birth </span>
                            <span class="validation-field-input">
                              <rn-form-input-state-control
                                [formReference]="form.get('verificationFields.date_of_birth')"
                                >
                                <input
                                  type="text"
                                  class="form-control"
                                  name="prompt-date_of_birth"
                                  formControlName="date_of_birth"
                                  />
                              </rn-form-input-state-control>
                            </span>
                          </div>
                          <div class="validation-fields-container">
                            <span class="validation-field-label">
                              postal_code
                              <span
                                matTooltip="Verification by postal code will only verify the first 5 digits if the customer has a 9 digit postal zip on file."
                                style="margin-left: 0.5rem"
                                >
                                <i
                                  class="fa fa-question-circle icon-color"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </span>
                            <span class="validation-field-input">
                              <rn-form-input-state-control
                                [formReference]="form.get('verificationFields.postal_code')"
                                >
                                <input
                                  type="text"
                                  class="form-control"
                                  name="prompt-postal_code"
                                  formControlName="postal_code"
                                  />
                              </rn-form-input-state-control>
                            </span>
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="input-label">Verification Page Message</label>
                          <rn-form-input-state-control
                            [formReference]="this.form.get('verificationFields.body')"
                            [totalLength]="getCharacterLimit('verificationBody')"
                            [showCharacterCount]="true"
                            >
                            <app-tiny-editor
                              class="tiny-editor-mentions"
                              [elementId]="'tiny-editor-verification-message'"
                              [formControl]="this.form.get('verificationFields.body')"
                              style="width: 100%"
                              [config]="tinyEditorConfig"
                              >
                            </app-tiny-editor>
                          </rn-form-input-state-control>
                        </div>
                        <div class="form-group">
                          <label>Submit Button Label</label>
                          <rn-form-input-state-control
                            [formReference]="this.form.get('verificationFields.button_label')"
                            [totalLength]="getCharacterLimit('verificationButtonLabel')"
                            [showCharacterCount]="true"
                            >
                            <input
                              type="text"
                              class="form-control"
                              [formControl]="this.form.get('verificationFields.button_label')"
                              placeholder="Submit"
                              />
                          </rn-form-input-state-control>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            }
            @if (productGroup.password.enabled) {
              <client-header
                [headerLabel]="'Password Page'"
                [headerGroup]="'password'"
                (click)="headerGroups.password = !headerGroups.password"
              ></client-header>
              @if (headerGroups.password) {
                <div
                  class="collapse-container"
                  style="height: 800px"
                  >
                  <div class="messaging-panel-signup arrow-left-center">
                    <div class="card panel-default">
                      <div class="card-header">
                        <div class="col-sm-12">Password Page Content</div>
                      </div>
                      <div class="card-body">
                        <div class="form-group">
                          <div>
                            <label>Set Password Text</label>
                          </div>
                          <div style="display: flex">
                            <rn-form-input-state-control
                              [formReference]="form.get('password.text')"
                              [isError]="passwordHasTextError()"
                              [showCharacterCount]="this.client.feed_enabled"
                              [totalLength]="getCharacterLimit('setPasswordText')"
                              >
                              <ng-container>
                                <app-tiny-editor
                                  class="tiny-editor-mentions"
                                  [elementId]="'tiny-editor-password-text'"
                                  [formControl]="form.get('password.text')"
                                ></app-tiny-editor>
                              </ng-container>
                            </rn-form-input-state-control>
                          </div>
                        </div>
                        <div class="form-group">
                          <div>
                            <label>Submit button label</label>
                          </div>
                          <div style="display: flex">
                            <rn-form-input-state-control
                              [formReference]="form.get('password.label')"
                              [showCharacterCount]="this.client.feed_enabled"
                    [totalLength]="
                      getCharacterLimit('setPasswordSubmitButtonLabel')
                    "
                              >
                              <ng-container>
                                <input
                                  name="button_label"
                                  class="form-control button_label"
                                  [formControl]="form.get('password.label')"
                                  />
                              </ng-container>
                            </rn-form-input-state-control>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <rn-generic-phone size="large">
                    <set-password-page-preview-react
                      [pswMessageText]="this.form.get('password.text').value || productGroup.password.text"
                      [pswButtonLabel]="this.form.get('password.label').value || productGroup.password.label"
                      [pswTCS]="this.form.get('passwordPageTC').value || productGroup.password.tcs"
                      [pswTCMandatory]="productGroup.password.tc_mandatory"
                      [logoUrl]="productGroup.branding.icon_s3_url"
                      [color]="productGroup.branding.color"
                      [productGroupName]="productGroup.name"
                      [showProductGroup]="!productGroup.hide_pg_wire_display_name"
                      [productGroupDescription]="productGroup.description"
                      [showFdic]="productGroup.fdic.show_signage_on_authentication"
                      [fdic]="productGroup.fdic"
                      [showLogo]="productGroup.show_logo"
                      [showTitleBar]="productGroup.show_title_bar"
            [consentContent]="
                productGroup.password.consent_upgrade_enabled &&
                (this.form.get('inFeedConsentUpgradeTC').value || productGroup.consent.in_wire_upgrade.ts_cs)
              "
                      language="es"
                    ></set-password-page-preview-react>
                  </rn-generic-phone>
                </div>
              }
            }
            @if (productGroup) {
              <div class="button-container clearfix">
                <button
                  type="submit"
                  id="next-btn"
                  class="btn btn-primary btn-with-icon"
                  [disabled]="form.invalid"
                  >
                  <span class="btn-label" i18n="Label for save button"> Finish </span>
                  <span class="icon icon-right">
                    <i class="fa fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            }
          </form>
        </ng-content>
      }

      <message-dialog></message-dialog>
